import { Modal } from "../ui/components/Modal";
import Api from "../api";

export class CancelRenewalModal extends Modal {
    init() {
        super.init()

        this.cancelBtn.on('click', this.handleCancelAutoRenewal.bind(this))
    }

    handleCancelAutoRenewal() {
        Api.post(this.cancelBtn.cancel_url).then(() => {
            this.hide();
            window.location.reload();
        })
    }
}
